export const prepositions = (value?: string) => {
    return value
      ? value
          .toString()
          .replace(
            /(\s|^)(a|i|k|o|s|u|v|z)(\s(a|i|k|o|s|u|v|z))?(\s+)/gim,
            '$1$2$3\u00A0',
          )
      : '';
  };